import { render, staticRenderFns } from "./SurveyDescriptionComponent.vue?vue&type=template&id=735f64e5&scoped=true"
import script from "./SurveyDescriptionComponent.vue?vue&type=script&lang=js"
export * from "./SurveyDescriptionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735f64e5",
  null
  
)

export default component.exports